import React, { useRef, useState } from 'react';
import { downloadDb, uploadDb } from '../utils/api';

const SqlPage = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const fileInputRef = useRef(null);

  const handleDownload = async (format = 'sqlite') => {
    try {
      setLoading(true);
      const response = await downloadDb(format);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = format === 'mysql' ? 'database_mysql.sql' : 'database.sqlite';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setMessage({ type: 'success', text: `Database downloaded as ${format.toUpperCase()} successfully` });
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: `Failed to download database as ${format.toUpperCase()}` });
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!window.confirm('Are you sure you want to replace the database? This action cannot be undone.')) {
        e.target.value = '';
        return;
    }

    const formData = new FormData();
    formData.append('database', file);

    try {
      setLoading(true);
      await uploadDb(formData);
      setMessage({ type: 'success', text: 'Database uploaded successfully. Refreshing page...' });
      setTimeout(() => window.location.reload(), 2000);
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: 'Failed to upload database' });
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-[#121214] text-white">
      <div className="w-full max-w-md bg-[#1C1C1E] rounded-[32px] p-8 border border-[#2C2C2E] shadow-2xl">
        <h1 className="text-3xl font-black italic tracking-tighter mb-8 text-center text-[#A3E635]">SQL MANAGEMENT</h1>
        
        {message && (
          <div className={`mb-6 p-4 rounded-2xl text-center font-bold ${message.type === 'success' ? 'bg-[#A3E635]/20 text-[#A3E635]' : 'bg-red-500/20 text-red-500'}`}>
            {message.text}
          </div>
        )}

        <div className="space-y-6">
          <button
            onClick={() => handleDownload('sqlite')}
            disabled={loading}
            className="w-full bg-[#2C2C2E] text-white font-black rounded-full py-4 text-xl hover:bg-[#3C3C3E] transition-all flex items-center justify-center gap-3 border border-[#3C3C3E]"
          >
            {loading ? 'PROCESSING...' : 'DOWNLOAD SQLITE'}
          </button>

          <button
            onClick={() => handleDownload('mysql')}
            disabled={loading}
            className="w-full bg-[#2C2C2E] text-white font-black rounded-full py-4 text-xl hover:bg-[#3C3C3E] transition-all flex items-center justify-center gap-3 border border-[#3C3C3E]"
          >
            {loading ? 'PROCESSING...' : 'DOWNLOAD MYSQL'}
          </button>

          <button
            onClick={() => fileInputRef.current.click()}
            disabled={loading}
            className="w-full bg-[#A3E635] text-black font-black rounded-full py-4 text-xl hover:scale-[1.02] transition-transform flex items-center justify-center gap-3 shadow-[0_0_20px_rgba(163,230,53,0.2)]"
          >
            {loading ? 'PROCESSING...' : 'UPLOAD DB'}
          </button>
          
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleUpload}
            className="hidden"
            accept=".sqlite,.sql"
          />
        </div>

        <p className="mt-8 text-sm text-gray-500 text-center italic">
          Accessing this page allows direct manipulation of the system's data. Use with caution.
        </p>
      </div>
    </div>
  );
};

export default SqlPage;
